const doc = [({"en":({"js":({"merfoto":({"routes":({"albums":({"albums":"Albums"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;